<template>
  <div>
    <CRow class="mb-4">
      <CCol>
        <CCard class="bg-style2">
          <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
            <span className="font-weight-bold h6"><CIcon name="cil-layers" size="lg"/> {{ caption }}</span>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="12">
<!--                $t('service.tqf')-->
                <CSelect :label="$t('organization')"
                         :disabled="disable"
                         :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"
                         :options="organization"
                         @update:value="onOrganization">
                </CSelect>
              </CCol>
              <CCol col="12" v-if="isAffiliation">
                <CSelect :label="$t('organization')"
                         :disabled="disable"
                         :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"
                         :options="affiliation"
                         @update:value="onAffiliation">
                </CSelect>
              </CCol>

              <CCol col="12">
                <CInput :label="$t('year')"
                        type="number"
                        :disabled="disable"
                        :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"
                        min="2566"
                        v-model="option.year"

                />
              </CCol>

            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>


import {mapGetters} from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'FilterOption',
  components: {Multiselect},
  props: {
    caption: {
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    },
    isAffiliation: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      // selecter
      organization:[],
      affiliation:[],

      option: {
        organization: null,
        affiliation: null,
        year: new Date().getFullYear() + 542,
      },




      campus: [],
      semesters: [
        {
          label: " 1",
          value: 1
        }, {
          label: " 2",
          value: 2
        }, {
          label: " 3",
          value: 3
        }
      ],
      course: [],


    }


  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.$store.dispatch("organization/config",{})

    },
    onOrganization(value, e) {
      this.option.organization = value;
      this.$emit("option", this.option)
    },

    onAffiliation(value, e) {
      this.option.affiliation = value;
      this.$emit("option", this.option)
    },


    // onLoadCourses() {
    //   this.$store.dispatch("courses/config", this.option)
    // },
    //
    // onSelectCampus(value, e) {
    //   this.option.campusId = value;
    //   this.onLoadCourses();
    //   this.$emit("option", this.option)
    // },
    //
    // onSemester(value, e) {
    //   this.option.semester = value;
    //   this.onLoadCourses();
    //   this.$emit("option", this.option)
    // },

  },


  computed: {
    ...mapGetters({
      objsLang: "setting/lang",
      objsOrganization: "organization/organization",
      // objsCampus: "campus/campus",
      // objsCourses: "courses/course",
    }),
  },

  watch: {
    objsLang(value){
      this.onInit();
    },

    objsOrganization(value){
      var lang = this.$store.getters['setting/lang']
      var items = [];
      value.filter(item => {
        var objs = item.title.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value;
        var data = {};
        data.label = objs
        data.value = item._id;
        items.push(data)
      })
      this.organization = items;

      this.option.organization = this.organization[0].value;


    },

    objsAffiliation(value){
      var lang = this.$store.getters['setting/lang']
      var items = [];

      var data = {};
      data.label = "-";
      data.value = 0;
      items.push(data)

      value.filter(item => {
        var objs = item.title.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value;
        var data = {};
        data.label = objs
        data.value = item._id;
        items.push(data)
      })
      this.affiliation = items;

      this.option.affiliation = this.affiliation[0].value;

    },
    "option.year"(value) {
      this.$emit("option", this.option)
    }
  }

}
</script>
<style>


</style>
